import React, { useCallback, useEffect, useState } from 'react'
import { Input } from '../../../components'
import { Modal } from 'antd'
import Icon from '../../../components/Icon'

const styleForIcon = {
  fontSize: 18,
  verticalAlign: 1,
  marginRight: 5,
}

const Edit = ({ active, collections, keys, onCancel, onOk, item }) => {

  let [name, setName] = useState(item.label)
  let [hasAdminAccess, setAdminAccess] = useState(item.hasAdminAccess)
  let [permissions, setPermissions] = useState(item.permissions)
  let [error, setError] = useState(false)

  useEffect(() => {
    setName(item.label)
    setPermissions(item.permissions)
    setAdminAccess(item.hasAdminAccess)
  }, [item])

  let submit = () => {
    const isOldName = item.label === name
    const isBusyName = !keys.find(k => k.label === name)
    if (isBusyName || isOldName) {
      onOk({
        ...item,
        label: name,
        hasAdminAccess,
        permissions,
      })
      setName('')
      setAdminAccess(false)
      setPermissions([])
      setError(false)
    } else {
      setError(true)
    }
  }

  const changePermission = useCallback((value) => {
    if (permissions.includes(value)) {
      setPermissions(permissions.filter(permission => permission !== value))
    } else {
      setPermissions([...permissions, value])
    }
  }, [permissions])
  return (
    <Modal
      title="Edit Key"
      visible={active}
      onCancel={onCancel}
      closable={false}
      width={410}
      footer={[
        <button key="submit" className={'btn btn-secondary dart-btn'}
                style={{ width: 125 }} onClick={submit}>
          Ok
        </button>,
        <button key="back"
                className={'btn btn-outline-secondary dart-btn-outline'}
                style={{ width: 125 }}
                onClick={onCancel}>Cancel</button>,
      ]}
    >

      <Input type={'text'} value={name} onChange={setName} label={'Label'}
             id={'modalNewTypeName'}/>
      {error && <p className={'text-danger'}>
        This label is busy.
      </p>}

      <div className="form-group form-check m-0">
        <input type="checkbox" id={'access'} className="form-check-input"
               value={''} checked={hasAdminAccess}
               onChange={() => setAdminAccess(
                 !hasAdminAccess)}/>
        <label className="form-check-label" htmlFor={'access'}>Allow this
          API key to create/modify/delete elements and catalogs</label>
      </div>
      <div className={'my-2'}>
        <label>Permissions</label>
        <div className={'w-100 p-2 knackly-back'}>
          <div className={'d-flex flex-row'}>
            <div className={'pb-2 pl-2 knacklyBlock d-flex'}>Catalog</div>
            <div className={'pb-2 knacklyBlock d-flex ml-2'}
            >Read/Write Access
            </div>
          </div>

          {collections.map(collection => (
            <div key={'permission-' + collection.name}
                 className={'d-flex flex-row'}>
              <div className={'knackly-plain py-2 pl-2 blockPermissions'}><Icon
                type={'icon-cabinet1'}
                style={styleForIcon}/>{collection.name}
              </div>
              <div className={'knackly-plain py-2 blockPermissions'}>
                <div className="form-check text-center p-0 m-0">
                  <input className="form-check-input position-static p-0 m-0"
                         type="checkbox"
                         onChange={() => changePermission(collection._id)}
                         checked={permissions.includes(collection._id)}/>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}

export default Edit
